module.exports = __webpack_public_path__ + "static/media/Avatars_Other-02.d871ab78.png";